import { customApiCall, getApiHost, IOptions } from '../utils/api';
import { API_ENDPOINTS } from '../constants/api';

export interface City {
    city_id: string;
    city_name: string;
}

export interface CityListResponse {
    status_code: number;
    status_message: string;
    data: {
        cities: City[];
    };
}

/**
 * Get list of cities
 */
export const fetchCityList = (): Promise<CityListResponse> => {
    const opts: IOptions = {
        method: "GET",
    };
    return customApiCall(getApiHost(), API_ENDPOINTS.GET_CITIES, opts);
};
